/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const territoryRemoteLookupSchema = z.any();

export const territoryRemoteLookupIdSchema = common.objectId;

export const territoryRemoteLookupItemSchema = z.object({
  id: common.objectId,
  name: z.string(),
  archived: z.boolean(),
});

export const territoryRemoteLookupFiltersSchema = z.object({ include_archived: z.boolean().nullable().optional() });

export const territoryRemoteLookupValidators = {
  id: territoryRemoteLookupIdSchema,
  item: territoryRemoteLookupItemSchema,
  filters: territoryRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: f9d7422e8262d4ff1431cec930cc6f17 */
